<template>
  <v-select
    :prepend-inner-icon="icon"
    label="POI Type"
    :outlined="outlined"
    item-text="name"
    item-value="id"
    :items="items"
    v-model="selectedTypeId"
    @change="onChange"
    hide-details=""
  ></v-select>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";

const POI_TYPES = gql`
  query routePoiTypes {
    routePoiTypes {
      edges {
        node {
          id
          name
          iconName
          iconSVG
        }
      }
    }
  }
`;
export default {
  name: "route-poi-type-select",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedTypeId: this.value && this.value.id ? this.value.id : "",
    };
  },

  computed: {
    items() {
      return this.routePoiTypes && this.routePoiTypes.edges
        ? this.routePoiTypes.edges.map(removeGQLTypename)
        : [];
    },
    selectedItem() {
      return this.items.length > 0
        ? this.items.find((item) => item.id == this.selectedTypeId)
        : null;
    },
    icon() {
      return this.selectedItem ? `mdi-${this.selectedItem.iconName}` : "";
    },
  },

  watch: {
    value(newVal) {
      this.selectedTypeId = newVal.id;
    },
  },

  methods: {
    onChange() {
      if (this.selectedItem) {
        this.$emit("input", { ...this.selectedItem });
      }
    },
  },

  apollo: {
    routePoiTypes: {
      query: POI_TYPES,
      result({ data }) {
        if (this.selectedTypeId == "") {
          this.selectedTypeId = this.items[0].id;
          this.$emit("input", { ...this.selectedItem });
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/RoutePoiTypeSelect.vue